import React, { useState, useEffect } from "react";
import { Stepper, Step, StepLabel, Container, Input, useEventCallback } from '@mui/material';

import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';

import { Radio, RadioGroup, FormLabel } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const EditBasicInfoConfParticipant = (props) => {
    const id = props.match.params.id;
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const [disabled, setdisabled] = useState(false);
    const [nameTitle, setNameTitle] = useState('');
    const [gender, setGender] = useState(''); // state to hold the selected value
    const [country, setCountry] = useState('Saudi Arabia');
    const [singleWorkShopCategory, setSingleWorkShopCategory] = useState('');
    const [workshopCategoryData, setWorkShopCategoryData] = useState([]);
    const [registrationType, setRegistrationType] = useState('');
    const workshop_particpant_email = localStorage.getItem('workshop_particpant_email');
    const conferenceName = localStorage.getItem('eventname')
    const [editWorkShopParticpant, setEditWorkShopParticpant] = React.useState({

        category_amount: "",
        is_active: "",
        name_title: "",
        participant_address: "",
        participant_city: "",
        participant_country: "",
        participant_email: "",
        particent_gender: "",
        participant_name: "",
        participant_phone_number: "",
        participant_profession: "",
        participant_saudi_council_no: "",
        categoy_id: "",
        password: "",
        grand_total_payment: '',
        conference_discount: '',
        total_payment: '',
        error_list: [],
    });

    useEffect(() => {
        axios.get(`api/conference-basic-information-participant-edit/${id}`)
            .then(res => {
                if (res.status === 200) {
                    const participantData = res.data.data.wparticipant;
                    const participantDataPayment = res.data.data.payment; // Accessing payment data correctly

                   

                    // Update the state with participant data
                    //setEditWorkShopParticpant(participantData);
                    // Update the state with participant data
                    setEditWorkShopParticpant({
                        ...participantData,
                        grand_total_payment: participantDataPayment ? participantDataPayment.grand_total_payment : '',
                        total_payment: participantDataPayment ? participantDataPayment.total_payment : '',
                        conference_discount: participantDataPayment ? participantDataPayment.conference_discount : '',
                        // ... your other state properties
                    });
                    setNameTitle(participantData.name_title);
                    setGender(participantData.participant_gender);
                    setCountry(participantData.participant_country);
                }
            })
            .catch(error => {
                console.error('Error fetching participant data:', error);
                // Handle error as needed
            });
    }, [id]);


    const handleInput = (e) => {
        const value = e.target.value;
        const inputName = e.target.name;
        setEditWorkShopParticpant({ ...editWorkShopParticpant, [e.target.name]: e.target.value });
        localStorage.setItem(inputName, value);

    }
    const handleCountry = (e) => {
        const selectCountry = e.target.value;
        setCountry(selectCountry);
        localStorage.setItem('selectedCountry', selectCountry);
    }
    const handleChange = (event) => {
        const selectedGender = event.target.value;
        setGender(selectedGender);
        localStorage.setItem('gender', selectedGender);
    };
    const handleNameTitle = (e) => {
        const selectNametitle = e.target.value;

        setNameTitle(selectNametitle);
        localStorage.setItem('nameTitle', selectNametitle)
    }

    const handleregistration = (e) => {
        const category = e.target.value;
        setRegistrationType(category);
    }

    const updateInformationWorkshopParticipant = (e) => {
        e.preventDefault();

        const data = {
            partiticipant_id: id,
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: editWorkShopParticpant.participant_saudi_council_no,
            participant_name: editWorkShopParticpant.participant_name,
            participant_email: editWorkShopParticpant.participant_email,
            //participant_workshop_categoy: singleWorkShopCategory.id,
            participant_contact: editWorkShopParticpant.participant_phone_number,
            participant_profession: editWorkShopParticpant.participant_profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: editWorkShopParticpant.participant_city,
            grand_total_payment: editWorkShopParticpant.grand_total_payment,
            conference_discount: editWorkShopParticpant.conference_discount,
            total_payment: editWorkShopParticpant.total_payment,
           

        }

        // console.log(data)
        // data.title == "" ? setdisabled(false) :
        //     data.descriptions == "" ? setdisabled(false) :
        //         setdisabled(true)

        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/conference-basic-information-participant-update/${id}`, data, config).then(res => {

                if (res.data.status === 200) {


                    swal('Success', res.data.message, 'success');

                   history.push('/admin/conference/manage-particpant');
                    // history.push('/workshop/thank-you');
                    return false;
                }
               

            });


        });


    }


    let backGroundButtonByEvent = "";
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);

    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    //backgroundColor: backGroundButtonByEvent,

    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '10%' }}>
                <h4 sx={{ m: 2, color: '#000000', marginTop: '2%', }} >
                    Update {conferenceName} Participant Basic Informations 
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        backgroundColor: backGroundButtonByEvent,
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={() => history.goBack()}>
                        Back
                    </Button>
                </h4>
                <Box component="form" onSubmit={updateInformationWorkshopParticipant} noValidate sx={{ mt: 3 }}>
                    <Grid container spacing={4}>

                        <Grid item xs={12} lg={6}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Title</InputLabel>
                                <Select
                                    value={nameTitle}
                                    onChange={handleNameTitle}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Action"
                                >
                                    <MenuItem value={'Mr'}>Mr</MenuItem>
                                    <MenuItem value={'Mrs'}>Mrs</MenuItem>
                                    <MenuItem value={'Ms'}>Ms</MenuItem>
                                    <MenuItem value={'Dr'}>Dr</MenuItem>
                                    <MenuItem value={'Prof'}>Prof</MenuItem>
                                    <MenuItem value={'Eng'}>Eng</MenuItem>
                                    <MenuItem value={'Sheikh'}>Sheikh</MenuItem>
                                </Select>

                            </FormControl>
                        </Grid>


                        <Grid item xs={6} >
                            <TextField
                                autoComplete="given-name"
                                required
                                fullWidth
                                label="Name"
                                autoFocus
                                name='participant_name' onChange={handleInput}
                                value={editWorkShopParticpant?.participant_name || ""}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                required
                                fullWidth
                                label="Saudi Council No"
                                type="text"
                                name='participant_saudi_council_no'
                                onChange={handleInput}
                                value={editWorkShopParticpant?.participant_saudi_council_no || ""}
                                helperText={editWorkShopParticpant?.error_list?.participant_saudi_council_no || ""}
                            />
                            <span style={{ color: 'red', textAlign: 'center' }}>
                                If you don't have, just type 0000
                            </span>
                        </Grid>

                        {/* <Grid item xs={12} lg={6}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Workshop Category</InputLabel>
                                <Select

                                    value={editWorkShopParticpant?.particent_workshop_categoy_id || ""}
                                    // onChange={handleWorkShopCategory}
                                    onChange={handleregistration}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Workshop Category" >
                                    {
                                        workshopCategoryData && workshopCategoryData.map((val, index) => {
                                            return (
                                                <MenuItem value={val.id} key={val.id}>{val.workshop_category_title} </MenuItem>
                                            )
                                        })
                                    }



                                </Select>

                               
                            </FormControl>
                        </Grid> */}
                        <Grid item xs={6}>
                            <TextField
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                autoComplete="particent_email"
                                name='participant_email'
                                onChange={handleInput}
                                value={editWorkShopParticpant?.participant_email || ""}
                                helperText={editWorkShopParticpant?.error_list?.participant_email || ""}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField
                                required
                                fullWidth
                                label="Contact Number"
                                type="text"
                                name='participant_phone_number'
                                onChange={handleInput}
                                value={editWorkShopParticpant?.participant_phone_number || ""}
                                helperText={editWorkShopParticpant?.error_list?.participant_phone_number || ""}
                            />

                        </Grid>



                        <Grid item xs={6} >
                            <TextField
                                autoComplete="given-name"
                                required
                                fullWidth

                                label="Profession"
                                autoFocus
                                name='participant_profession'
                                onChange={handleInput} value={editWorkShopParticpant?.participant_profession || ""}
                                helperText={editWorkShopParticpant?.error_list?.participant_profession} />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl>
                                <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={gender.toString()}  // Convert the numeric value to a string
                                    onChange={handleChange}
                                >
                                    <FormControlLabel value="0" control={<Radio />} label="Male" />
                                    <FormControlLabel value="1" control={<Radio />} label="Female" />
                                </RadioGroup>

                            </FormControl>
                        </Grid>


                        <Grid item xs={12} lg={6}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Country</InputLabel>
                                <Select
                                    value={country || ""}
                                    onChange={handleCountry}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Action" >
                                    <MenuItem value={'Saudi Arabia'}>Saudi Arabia</MenuItem>
                                    <MenuItem value={'UAE'}>UAE</MenuItem>
                                    <MenuItem value={'Qatar'}> Qatar</MenuItem>
                                    <MenuItem value={'Oman'}>Oman </MenuItem>
                                    <MenuItem value={'Jordan'}>Jordan</MenuItem>
                                    <MenuItem value={'Trurky'}>Trurky </MenuItem>

                                </Select>
                                <FormHelperText></FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item xs={6} >
                            <TextField
                                autoComplete="given-name"
                                required
                                fullWidth
                                label="City"
                                autoFocus
                                name='participant_city' onChange={handleInput} value={editWorkShopParticpant?.participant_city || ""} />
                        </Grid>
                        
                       
                        <Grid item xs={6} >
                            <TextField
                                autoComplete="given-name"
                                required
                                fullWidth
                                label="Total"
                                autoFocus
                                name='total_payment' onChange={handleInput} value={editWorkShopParticpant?.total_payment || ""} />
                        </Grid>
                        <Grid item xs={6} >
                            <TextField
                                autoComplete="given-name"
                                required
                                fullWidth
                                label="Grand Total"
                                autoFocus
                                name='grand_total_payment' onChange={handleInput} value={editWorkShopParticpant?.grand_total_payment || ""} />
                        </Grid>
                        <Grid item xs={6} >
                            <TextField
                                autoComplete="given-name"
                                required
                                fullWidth
                                label="Discount"
                                autoFocus
                                name='conference_discount' onChange={handleInput} value={editWorkShopParticpant?.conference_discount || ""} />
                        </Grid>
                    </Grid>
                    <Grid container justifyContent="flex-end">
                        <Button
                            disabled={disabled}
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{ mt: 5, backgroundColor: backGroundButtonByEvent, }} >
                            update Participant
                        </Button>
                    </Grid>


                </Box>
            </Box>
        </div>
    );
}

export default EditBasicInfoConfParticipant;
